module.exports = __webpack_public_path__ + "img/Number=116.01f3b941.png";